export const randomColourIdGenerator = (str: string) => (str || '').charCodeAt(0) % 13 || 1
